import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { getColumnList } from '@common-reducers/TaskSelectors';
import { useAppSelector } from '@common-reducers/hooks/store.hook';
import React from 'react';
import { usePortalContainer } from "@/common/hooks/use-portal-container";

type FilterRowColumnFieldProps = {
    selectedColumnId?: string; // Changed from columnField to selectedColumnId for better binding
    onColumnChange: (columnItemId: string) => void; 
};

export const FilterRowColumnFieldShadcn: React.FC<FilterRowColumnFieldProps> = ({ selectedColumnId, onColumnChange }) => {
    const columnList = useAppSelector(getColumnList);
    const localPortalContainer = usePortalContainer();

    const handleChange = (value: string) => {
         onColumnChange(value);
    };

    return (
        <Select value={selectedColumnId || ''} onValueChange={handleChange}>
            <SelectTrigger className="w-full h-9">
                <SelectValue placeholder="Column" />
            </SelectTrigger>
            <SelectContent> 
                <SelectItem value="groupColumn">Group</SelectItem>
                {columnList.map((column) => (
                    <SelectItem key={column._id} value={column._id ?? ''}>
                        {column.title || column.type}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}
